import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { GET_STORE_DETAILS } from "../../../../operations/queries/operations/queries/get-store-details.js";
import { fromStoreQueryDataToStoreDetails } from "../../adapters/hooks/api/adapters/fromStoreQueryDataToStoreDetails.js";
const useStoreDetails = () => {
  const { locale } = useIntl();
  const [query, queryState] = useLazyQuery(
    GET_STORE_DETAILS,
    {
      context: {
        forwardHeaders: {
          "Accept-Language": locale
        }
      },
      fetchPolicy: "no-cache"
    }
  );
  const data = React.useMemo(() => {
    const storeQueryData = queryState.data?.store;
    return fromStoreQueryDataToStoreDetails(storeQueryData);
  }, [queryState.data]);
  const getStoreDetails = React.useCallback(
    (slugOrCode) => {
      query({
        variables: {
          [typeof slugOrCode === "string" ? "slug" : "code"]: slugOrCode
        }
      });
    },
    [query]
  );
  React.useEffect(() => {
    if (queryState.error) {
      console.error("Failed to fetch store details: ", queryState.error);
    }
  }, [queryState.error]);
  return React.useMemo(
    () => [getStoreDetails, { ...queryState, data }],
    [getStoreDetails, queryState, data]
  );
};
const useStoreDetailsWithGlobalStoreId = () => {
  const { locale } = useIntl();
  const [query, queryState] = useLazyQuery(
    GET_STORE_DETAILS,
    {
      context: {
        forwardHeaders: {
          "Accept-Language": locale
        }
      },
      fetchPolicy: "no-cache"
    }
  );
  const data = React.useMemo(() => {
    const storeQueryData = queryState.data?.store;
    return fromStoreQueryDataToStoreDetails(storeQueryData);
  }, [queryState.data]);
  const getStoreDetails = React.useCallback(
    (globalStoreId) => {
      query({
        variables: {
          globalStoreId
        }
      });
    },
    [query]
  );
  React.useEffect(() => {
    if (queryState.error) {
      console.error("Failed to fetch store details: ", queryState.error);
    }
  }, [queryState.error]);
  return React.useMemo(
    () => [getStoreDetails, { ...queryState, data }],
    [getStoreDetails, queryState, data]
  );
};
export {
  useStoreDetails as default,
  useStoreDetails,
  useStoreDetailsWithGlobalStoreId
};
//# sourceMappingURL=use-store-details.js.map
